import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="section-form"
export default class extends Controller {
  static targets = ["warning", "column", "sectionType", "columnContainer", "columnContainerHint", "renderRawData"]

  connect() {
    this.sectionTypeChanged();
  }

  showWarning() {
    this.warningTarget.classList.remove("hidden");
  }

  toggleColumns(selectedColumns) {
    this.columnTargets.forEach(column => {
      if (column.dataset.index < selectedColumns) {
        column.classList.remove("hidden");
      } else {
        column.classList.add("hidden");
      }
    });

    if (selectedColumns > 0) {
      this.columnContainerHintTarget.classList.remove("hidden");
    } else {
      this.columnContainerHintTarget.classList.add("hidden");
    }
  }

  sectionTypeChanged() {
    this.checkIfRenderRawData();

    const selectedColumns = parseInt(this.sectionTypeTarget.value.split("-")[0])

    if (Number.isNaN(selectedColumns)) {
      this.toggleColumns(0);
      return;
    }

    this.toggleColumns(selectedColumns);
    this.columnContainerTarget.style.columns = selectedColumns;
  }

  checkIfRenderRawData() {
    if (this.sectionTypeTarget.value.includes("chart") || this.sectionTypeTarget.value.includes("questions")) {
      this.renderRawDataTarget.classList.remove("hidden");
    } else {
      this.renderRawDataTarget.classList.add("hidden");
    }
  }
}
